<template>
  <div class="c-layout">
    <Header genre-name="" genre-slug="/" simplified />
    <div :class="['c-layout--main', 'v-error']">
      <h1 class="v-error--title">{{ $t('ERROR.NO_ACCESS_TITLE') }}</h1>
      <section class="v-error--message">{{ $t('ERROR.NO_ACCESS_MESSAGE') }}</section>
    </div>

    <CookieFooter />
    <ModalContainer />
  </div>
</template>

<script setup lang="ts">
import CookieFooter from '@/components/cookie-footer/CookieFooter.vue';
import Header from '@/components/header/BaseHeader.vue';
import ModalContainer from '@/components/layout/modal/ModalContainer.vue';
</script>
